import * as angular from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ContentTemplatesRequestsService} from "./content-templates-requests.service";
import {ILogService, IQService} from "angular";
import {ContentTemplatesAlertsService} from "./content-templates-alerts.service";
import {ContentTemplateModel} from "../models/content-template.model";

export class ContentTemplatesService {

  constructor(private contentTemplatesRequestsService: ContentTemplatesRequestsService, private contentTemplatesAlertsService: ContentTemplatesAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log: ILogService, private $q: IQService) {
  }


  getExternalTemplate(externalTemplateId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contentTemplatesRequestsService.getExternalTemplate(externalTemplateId)
      .then((externalTemplate) => {
        deferred.resolve(externalTemplate);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contentTemplatesAlertsService.getExternalTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


  createTemplate(contentTemplate: ContentTemplateModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contentTemplatesRequestsService.createTemplate(contentTemplate)
      .then((contentTemplate: ContentTemplateModel) => {
        this.contentTemplatesAlertsService.createTemplateSuccess();
        deferred.resolve(contentTemplate);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contentTemplatesAlertsService.createTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editTemplate(contentTemplateId: string, contentTemplate: ContentTemplateModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contentTemplatesRequestsService.editTemplate(contentTemplateId, contentTemplate)
      .then((contentTemplate: ContentTemplateModel) => {
        this.contentTemplatesAlertsService.editTemplateSuccess();
        deferred.resolve(contentTemplate);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contentTemplatesAlertsService.editTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteTemplate(contentTemplateId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.contentTemplatesRequestsService.deleteTemplate(contentTemplateId)
      .then((res) => {
        this.contentTemplatesAlertsService.deleteTemplateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        this.contentTemplatesAlertsService.deleteTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }
}

angular
  .module('bringoz.admin.content-templates')
  .service('contentTemplatesService', ContentTemplatesService);
